import React from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Box } from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
import { useTranslation } from 'react-i18next';
import { styled, alpha } from '@mui/material/styles';

// Özel stil tanımlamaları
const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
    boxShadow: `0 4px 20px 0px ${alpha(theme.palette.primary.main, 0.15)}`,
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      padding: theme.spacing(1.5, 2),
      '& .MuiListItemIcon-root': {
        minWidth: 36,
      },
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
      },
      '&.selected': {
        backgroundColor: alpha(theme.palette.primary.main, 0.15),
        '& .MuiTypography-root': {
          color: theme.palette.primary.main,
        },
      },
    },
  },
}));

const languages = [
  {
    code: 'en',
    name: 'English',
    flag: 'EN'
  },
  {
    code: 'tr',
    name: 'Türkçe',
    flag: 'TR'
  }
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    handleClose();
  };

  return (
    <>
      <IconButton
        color="primary"
        onClick={handleClick}
        aria-controls="language-menu"
        aria-haspopup="true"
        sx={{
          transition: 'all 0.2s',
          '&:hover': {
            transform: 'scale(1.1)',
            backgroundColor: alpha('#90caf9', 0.1),
          }
        }}
      >
        <TranslateIcon />
      </IconButton>
      <StyledMenu
        id="language-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={i18n.language === lang.code ? 'selected' : ''}
          >
            <ListItemIcon>
              <Box 
                component="span" 
                sx={{ 
                  fontSize: '0.875rem',
                  fontWeight: 600,
                  color: theme => i18n.language === lang.code ? theme.palette.primary.main : 'inherit',
                  width: 24,
                  textAlign: 'center'
                }}
              >
                {lang.flag}
              </Box>
            </ListItemIcon>
            <ListItemText 
              primary={lang.name}
              sx={{
                '& .MuiTypography-root': {
                  fontWeight: i18n.language === lang.code ? 600 : 400,
                  transition: 'color 0.2s',
                }
              }}
            />
          </MenuItem>
        ))}
      </StyledMenu>
    </>
  );
};

export default LanguageSwitcher;
